import React, { useEffect, lazy, Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import './styles/App.css';
import { HelmetProvider } from 'react-helmet-async';
import SEOManager from './components/SEOManager';
import NotFound from './pages/NotFound';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { AuthProvider } from './contexts/AuthContext';
import { AccessProvider } from './contexts/AccessContext';
import { ProtectedRoute } from './components/Auth/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import ResetPasswordPage from './pages/ResetPasswordPage';

const AdminDashboard  = lazy(() => import('./pages/AdminDashboard'));
const ExpertDashboard = lazy(() => import('./pages/ExpertDashboard'));
// import MaverickDashboard from './pages/MaverickDashboard';
// import GuardianDashboard from './pages/GuardianDashboard';
// Landing Page Components
// import Sidebar from './components/Navigation/Sidebar';
// import TopNav from './components/Navigation/TopNav';
// import DaatLogo from './components/Navigation/DaatLogo';
// import HeroSection from './components/LandingSections/HeroSection';
// import CuriositySection from './components/LandingSections/CuriositySection';
// import ConnectSection from './components/LandingSections/ConnectSection';
// import JaliSection from './components/LandingSections/JaliSection';

const ConnectPage   = lazy(() => import('./pages/ConnectPage'));
const SpacesPage    = lazy(() => import('./pages/SpacesPage'));
const JaliPage      = lazy(() => import('./pages/JaliPage'));
const ExpertsPage   = lazy(() => import('./pages/ExpertsPage'));
const GuardiansPage = lazy(() => import('./pages/GuardiansPage'));
const MavericksPage = lazy(() => import('./pages/MavericksPage'));
const ShortFilmsPage = lazy(() => import('./pages/ShortFilmsPage'));
const ArticlesPage  = lazy(() => import('./pages/ArticlesPage'));
const VisionPage    = lazy(() => import('./pages/VisionPage'));
const FilmsPage     = lazy(() => import('./pages/FilmsPage'));
const EventsPage    = lazy(() => import('./pages/EventsPage'));
const PressPage     = lazy(() => import('./pages/PressPage'));
const PartnerPage   = lazy(() => import('./pages/PartnerPage'));
const EnquiriesPage = lazy(() => import('./pages/EnquiriesPage'));
const JaliStories   = lazy(() => import('./pages/JaliStories'));
const DiscoverPage  = lazy(() => import('./pages/DiscoverPage'));
const CareersPage   = lazy(() => import('./pages/CareersPage'));
const CooperHewittPage      = lazy(() => import('./pages/CooperHewittPage'));
const CooperLearnMore       = lazy(() => import('./pages/CooperLearnMore'));
const DaatModernismDetail   = lazy(() => import('./pages/events/DaatModernismDetail'));
const GriotsPage            = lazy(() => import('./pages/GriotsPage'));
const MissionPage           = lazy(() => import('./pages/MissionPage'));
const DesignPage            = lazy(() => import('./pages/DesignPage'));
const OromoChairPage        = lazy(() => import('./pages/OromoChairPage'));
// Expert detail pages
// import JomoTarikuPage from './pages/experts/JomoTarikuPage';
// import SandraGithinjiPage from './pages/experts/SandraGithinjiPage';
// import VanessaKingoriPage from './pages/experts/VanessaKingoriPage';
// import EstherMahlanguPage from './pages/experts/EstherMahlanguPage';
// import FatoumataDiabatePage from './pages/experts/FatoumataDiabatePage';
// import KwameAkotoBamfoPage from './pages/experts/KwameAkotoBamfoPage';
// import SirDavidAdjayePage from './pages/experts/SirDavidAdjayePage';
// import DiebedoFrancisKerePage from './pages/experts/DiebedoFrancisKerePage';
// import DoreenAdengoPage from './pages/experts/DoreenAdengoPage';
const MavericksCategoryPage = lazy(() => import('./pages/MavericksCategoryPage'));
const ExpertProfilePage     = lazy(() => import('./pages/ExpertProfilePage'));
const MaverickProfilePage   = lazy(() => import('./pages/MaverickProfilePage'));
// Guardians details pages
// import ChaibiaTalalPage from './pages/guardians/ChaibiaTalalPage';
// import HassanFathyPage from './pages/guardians/HassanFathyPage';
// import KofiAntubamPage from './pages/guardians/KofiAntubamPage';
// import KossiAguessyPage from './pages/guardians/KossiAguessyPage';
// import LaCorbusierPage from './pages/guardians/LaCorbusierPage';
// import LadiKwaliPage from './pages/guardians/LadiKwaliPage';
// import OloweOfIsePage from './pages/guardians/OloweOfIsePage';
// import PabloPicassoPage from './pages/guardians/PabloPicassoPage';
// import ZahaHadidPage from './pages/guardians/ZahaHadidPage';
const GuardianProfilePage   = lazy(() => import('./pages/GuardianProfilePage'));
const NdoomeShield          = lazy(() => import('./pages/design/NdoomeShield'));
const MangamMask            = lazy(() => import('./pages/design/MangamMask'));
const OromoChair            = lazy(() => import('./pages/design/OromoChair'));
const ShonaPeople           = lazy(() => import('./pages/design/ShonaPeoples'));
const CooperHewittDemo      = lazy(() => import('./components/InteractiveImage'));
const ExpertsCategoryPage   = lazy(() => import('./pages/ExpertsCategoryPage'));
// Coming Soon Components (Kept for reference, commented out in main display)
// import ImageCarousel from './components/ImageCarousel';
// import StayConnectedForm from './components/StayConnectedForm';
// import PartnersPage from './components/PartnersPage';


const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const getOrCreateSessionKey = () => {
  let key = localStorage.getItem('daat_session');
  if (!key) {
    key = Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem('daat_session', key);
  }
  return key;
};

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    fetch(`${API}/api/page/visit/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        page: location.pathname,
        session_key: getOrCreateSessionKey(),
      }),
    }).catch(() => {});
  }, [location.pathname]);

  return null;
};
function App() {
  /* ========================================
     ORIGINAL COMING SOON PAGE CODE (COMMENTED OUT)
     ======================================== */
  
  /*
  const [showPartnerForm, setShowPartnerForm] = useState(false);
  const [showStayConnected, setShowStayConnected] = useState(false);
  const [showPartnersPage, setShowPartnersPage] = useState(false);
  const [isFading, setIsFading] = useState(false);
  const [showScrollDown, setShowScrollDown] = useState(true);
  const [showScrollUp, setShowScrollUp] = useState(false);

  // Handle scroll visibility
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      
      // Show scroll down indicator only on first section
      setShowScrollDown(scrollPosition < windowHeight * 0.3);
      
      // Show scroll up indicator when not at the top
      setShowScrollUp(scrollPosition > windowHeight * 0.3);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleOpenPartnersPage = () => {
    setIsFading(true);
    setTimeout(() => {
      setShowPartnersPage(true);
      setIsFading(false);
    }, 2000);
  };

  const handleClosePartnersPage = () => {
    setIsFading(true);
    setTimeout(() => {
      setShowPartnersPage(false);
      setIsFading(false);
    }, 2000);
  };

  const handleOpenStayConnected = () => {
    setIsFading(true);
    setTimeout(() => {
      setShowStayConnected(true);
      setIsFading(false);
    }, 2000);
  };

  const handleCloseStayConnected = () => {
    setIsFading(true);
    setTimeout(() => {
      setShowStayConnected(false);
      setIsFading(false);
    }, 2000);
  };

  const scrollToNextSection = () => {
    window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="app overflow-y-auto">
      <div 
        className={`fixed inset-0 bg-black z-[10000] pointer-events-none transition-opacity duration-[2000ms] ${
          isFading ? 'opacity-100' : 'opacity-0'
        }`}
      />

      {showScrollDown && (
        <div 
          className="fixed bottom-6 sm:bottom-8 md:bottom-10 right-6 sm:right-8 md:right-10 z-50 flex flex-col items-center cursor-pointer group transition-opacity duration-300"
          onClick={scrollToNextSection}
        >
          <svg 
            width="36" 
            height="36" 
            viewBox="0 0 30 30" 
            className="text-[#A47F2D] animate-bounce group-hover:text-[#B8935D] transition-colors w-9 h-9 sm:w-10 sm:h-10 md:w-12 md:h-12"
          >
            <path d="M7 10L15 18L23 10" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/>
            <path d="M7 15L15 23L23 15" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.5"/>
          </svg>
        </div>
      )}

      {showScrollUp && (
        <div 
          className="fixed top-6 sm:top-8 md:top-10 right-6 sm:right-8 md:right-10 z-50 flex flex-col items-center cursor-pointer group transition-opacity duration-300"
          onClick={scrollToTop}
        >
          <svg 
            width="48" 
            height="48" 
            viewBox="0 0 30 30" 
            className="text-[#A47F2D] animate-bounce group-hover:text-[#B8935D] transition-colors w-12 h-12 sm:w-14 sm:h-14 md:w-16 md:h-16"
          >
            <path d="M23 20L15 12L7 20" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round"/>
            <path d="M23 15L15 7L7 15" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.5"/>
          </svg>
        </div>
      )}

      <section className="w-full h-screen relative flex items-center justify-center">
        <ImageCarousel />
      </section>

      <section className="min-h-screen w-full flex flex-col justify-center px-0 py-0">
        <div className="hero-text">
          <h1>
            <span className="line-1">THE CONTINUUM OF HERITAGE</span>
            <span className="line-2">SHAPING DESIGN</span>
          </h1>
          <p>A dynamic intersection of Design, Art, Architecture and Technology, rooted in the timeless expression of Africa's rich heritage.</p>
        </div>

        <div className="flex flex-wrap gap-4 sm:gap-6 justify-center px-4 -mt-12 relative z-10">
          <button 
            onClick={handleOpenPartnersPage}
            disabled={isFading}
            className="w-36 xs:w-40 sm:w-52 md:w-60 lg:w-72 px-3 xs:px-4 sm:px-6 md:px-8 py-1.5 xs:py-2 sm:py-2.5 md:py-3.5 text-[9px] xs:text-[10px] sm:text-xs md:text-sm lg:text-base font-medium text-white border-2 border-white/80 rounded-full transition-all duration-300 ease-in-out uppercase tracking-wide hover:text-[#A47F2D] hover:border-[#A47F2D] hover:-translate-y-1 hover:scale-x-110 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Step Into the Vision
          </button>

          <button 
            onClick={handleOpenStayConnected}
            disabled={isFading}
            className="w-36 xs:w-40 sm:w-52 md:w-60 lg:w-72 px-3 xs:px-4 sm:px-6 md:px-8 py-1.5 xs:py-2 sm:py-2.5 md:py-3.5 text-[9px] xs:text-[10px] sm:text-xs md:text-sm lg:text-base font-medium text-white border-2 border-white/80 rounded-full transition-all duration-300 ease-in-out uppercase tracking-wide hover:text-[#A47F2D] hover:border-[#A47F2D] hover:-translate-y-1 hover:scale-x-110 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Stay Connected
          </button>
        </div>
      </section>

      <PartnersPage 
        isOpen={showPartnersPage}
        onClose={handleClosePartnersPage}
      />

      <StayConnectedForm 
        isOpen={showStayConnected}
        onClose={handleCloseStayConnected}
      />
    </div>
  );
  */

  /* ========================================
     END OF COMMENTED OUT COMING SOON CODE
     ======================================== */


  /* ========================================
     NEW LANDING PAGE DISPLAY (MILESTONE 2)
     NO ROUTER NEEDED - DIRECT DISPLAY
     ======================================== */


    return (
    <HelmetProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>

          <AccessProvider>
          <PageTracker />
          <SEOManager />
          <Suspense fallback={<div style={{ background: '#000', minHeight: '100vh' }} />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/connect" element={<ConnectPage />} />
          <Route path="/spaces" element={<SpacesPage />} />
          <Route path="/jali" element={<JaliPage />} />
          <Route path="/griots" element={<GriotsPage />} />
          <Route path="/experts" element={<ExpertsPage />} />
          <Route path="/guardians" element={<GuardiansPage />} />
          <Route path="/mavericks" element={<MavericksPage />} />
          <Route path="/mission" element={<MissionPage />} />
          <Route path="/mavericks/all" element={<MavericksCategoryPage />} />
          <Route path="/mavericks/:slug" element={<MaverickProfilePage />} />
          <Route path="/short-films" element={<ShortFilmsPage />} />
          <Route path="/films" element={<FilmsPage />} />
          <Route path="/vision" element={<VisionPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/articles" element={<ArticlesPage />} />
          <Route path="/press" element={<PressPage />} />
          <Route path="/partner" element={<PartnerPage />} />
          <Route path="/press/enquire" element={<EnquiriesPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/discover" element={<DiscoverPage />} />
          <Route path="/jali-stories" element={<JaliStories />} />
          <Route path="/cooper-hewitt" element={<CooperHewittPage />} />
          <Route path="/cooper-learn-more" element={<CooperLearnMore />} />
          <Route path="/events/daat-modernism" element={<DaatModernismDetail />} />


        <Route path="/design"               element={<DesignPage />}    />
        <Route path="/discover/oromo-chair" element={<OromoChairPage />} />
          {/* Expert Detail Pages */}
          <Route path="/experts/category/:category" element={<ExpertsCategoryPage />} />
        <Route path="/experts/:slug" element={<ExpertProfilePage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

{/* 



          {/* Guradians Detail Pages */}
        

        <Route path="/guardians/:slug" element={<GuardianProfilePage />} />
        <Route path="/interactive" element={<CooperHewittDemo />} />

          {/* Discover Pages */}
          <Route path="/discover/ndoome-shield" element={<NdoomeShield />} />
          <Route path="/discover/mangam-mask" element={<MangamMask />} />
          <Route path="/discover/oromo-chair" element={<OromoChair />} />
          <Route path="/discover/shona-people" element={<ShonaPeople />} />

          <Route path="*" element={<NotFound />} />


          {/* ========================================
              AUTHENTICATION & DASHBOARD ROUTES
              ======================================== */}
          
          {/* Protected Admin Route */}
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* Protected User Routes - Role-specific dashboards */}
          <Route 
            path="/dashboard/expert" 
            element={
              <ProtectedRoute allowedRoles={['expert']}>
                <ExpertDashboard />
              </ProtectedRoute>
            } 
          />
          
          {/* <Route 
            path="/dashboard/maverick" 
            element={
              <ProtectedRoute allowedRoles={['maverick']}>
                <MaverickDashboard />
              </ProtectedRoute>
            } 
          /> */}
          
          {/* <Route 
            path="/dashboard/guardian" 
            element={
              <ProtectedRoute allowedRoles={['guardian']}>
                <GuardianDashboard />
              </ProtectedRoute>
            } 
          /> */}
          
       </Routes>
       </Suspense>
      </AccessProvider>
      </AuthProvider>

    </Router>
    </HelmetProvider>
    );

}

export default App;